/**
 * @generated SignedSource<<bdf446de78eb7ae0a8f92a3730eddb03>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueLinkingProvider$data = {
  readonly jira: {
    readonly issueLinkTypes: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "IssueLinkingProvider";
};
export type IssueLinkingProvider$key = {
  readonly " $data"?: IssueLinkingProvider$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueLinkingProvider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "IssueLinkingProvider",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraIssueLinkTypeConnection",
          "kind": "LinkedField",
          "name": "issueLinkTypes",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "totalCount"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "eb941d2ee07647bf13cbdaa1e8d02999";

export default node;
